import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { GuardService } from '@shared/services/guard.service';
import { SummaryReportService } from '@shared/services/summary-report.service';
import { ISummaryReport } from '@shared/interfaces';
import { MatDialog } from '@angular/material/dialog';
import { SnackService } from '@shared/services/snack.service';
import { CacheService } from '@shared/services/cache.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DialogService, NavigationService } from '@shared/services';
import {} from '@shared/interfaces/queries/IQuerySummaryReport';
import { SummaryReportDirective } from './directives/summary-report.directive';
import { SummaryReportViewComponent } from './components/summary-report-view/summary-report-view.component';

@Component({
    selector: 'app-summary-report',
    templateUrl: './summary-report.component.html',
    styleUrls: ['./summary-report.component.scss'],
    standalone: false
})
export class SummaryReportComponent extends SummaryReportDirective implements OnInit {
    @ViewChild(SummaryReportViewComponent) viewComponent: SummaryReportViewComponent;

    constructor(
        protected summaryReportService: SummaryReportService,
        protected dialog: MatDialog,
        protected snackService: SnackService,
        protected cacheService: CacheService,
        protected dialogService: DialogService,
        protected guardService: GuardService,
        protected router: Router,
        protected route: ActivatedRoute,
        protected changeDetection: ChangeDetectorRef,
        protected location: Location,
        protected navigationService: NavigationService
    ) {
        super(
            guardService,
            changeDetection,
            cacheService,
            router,
            route,
            location,
            navigationService,
            summaryReportService
        );
    }

    public async ngOnInit(): Promise<void> {
        await super.ngOnInit();
    }

    protected async deleteItem(item: ISummaryReport): Promise<void> {
        try {
            const result = await this.dialogService.deleteDialog();
            if (!result) {
                return;
            }
        } catch (error) {
            throw new Error('Failed to confirm summary report deletion.', { cause: error });
        }

        try {
            await this.summaryReportService.delete(item);
            this.snackService.openSnackBarSuccess('Summary report deleted successfully.');
            await this.viewComponent.reloadData();
        } catch (_error) {
            this.snackService.openSnackBarError('An error has occurred!');
        }
    }
}
